import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducerMap, StoreModule } from '@ngrx/store';

import { CompanyUsersStateEffects } from './company-users/company-users-state.effects';
import { CompanyUsersStateReducer } from './company-users/company-users-state.reducer';
import { FeatureFlagStateEffects } from './feature-flag/feature-flag-state.effects';
import { featureFlagStateReducer } from './feature-flag/feature-flag-state.reducer';
import { TeamListStateEffects } from './team-list/team-list-state.effects';
import { teamListStateReducer } from './team-list/team-list-state.reducer';
import { UserListStateEffects } from './user-list/user-list-state.effects';
import { UserListStateReducer } from './user-list/user-list-state.reducer';
import { UsersStateEffects } from './users/users-state.effects';
import { UsersStateReducer } from './users/users-state.reducer';

import {
  AppEntitiesState,
  CompanyUsersStateKey,
  FeatureFlagStateKey,
  TeamListStateKey,
  UserListStateKey,
  UsersStateKey,
  appEntitiesStateKey,
} from '.';

export const appEntitiesStateReducers: ActionReducerMap<AppEntitiesState> = {
  [FeatureFlagStateKey]: featureFlagStateReducer,
  [UsersStateKey]: UsersStateReducer,
  [CompanyUsersStateKey]: CompanyUsersStateReducer,
  [TeamListStateKey]: teamListStateReducer,
  [UserListStateKey]: UserListStateReducer,
};

@NgModule({
  imports: [
    StoreModule.forFeature(appEntitiesStateKey, appEntitiesStateReducers),
    EffectsModule.forFeature([
      FeatureFlagStateEffects,
      UsersStateEffects,
      TeamListStateEffects,
      UserListStateEffects,
      CompanyUsersStateEffects,
    ]),
  ],
})
export class AppEntitiesStateModule {}
